import { ActivityBar as ActivityBarType, calculateMaxActivityValue } from '../../../../core/utils/ooh/oohCalculations';

interface ActivityBarProps {
  activities: ActivityBarType[];
}

const ActivityBar = ({ activities }: ActivityBarProps) => {
  const maxValue = calculateMaxActivityValue(activities);

  return (
    <div className="space-y-1">
      {activities.map((activity, index) => (
        <div key={index} className="flex items-center gap-2 text-xs">
          <div
            className="h-2 min-w-[20px] rounded-full"
            style={{
              backgroundColor: activity.color,
              width: `${Math.max(20, (activity.value / maxValue) * 60)}px`,
            }}
          />
          <span className="font-medium">
            {activity.label}: {activity.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ActivityBar;